const state = {
    errors: {},
    componentErrors: []
};

const mutations = {
    set: (state, errors) => {
        state.errors = errors;
    },
    setByComponentId: (state, errors) => {
        state.componentErrors[errors.componentId] = errors;
    },
    unset: (state) => {
        state.errors = {};
    },
    unsetByComponentId: (state, componentId) => {
        delete state.componentErrors[componentId];
    }
};

const getters = {
    get: (state) => {
        return state.errors;
    },

    getByComponentId: (state) => (componentId) => {
        return state.componentErrors[componentId];
    },

    getByNameInComponentId: (state) => (componentId, name) => {
        if (state.componentErrors[componentId]) {
            if (state.componentErrors[componentId][name]) {
                return state.componentErrors[componentId][name];
            } else {
                return {};
            }
        } else {
            return {};
        }
    },

    getByName: (state) => (name) => {
        return state.errors[name];
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
};
